import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, map } from 'rxjs';
import { ThemingService } from '../theming/theming.service';
import { ThemingQueryParams } from '../theming/theming.model';
import { LoaderComponent } from '@tribeauto/ngx-mobilite-material';
import { SocietyCode } from '../stepper/stepper.model';
import { ApplicationStore } from '../application/application-store.service';
import { TranslatePipe } from '@ngx-translate/core';
import { OpenBankingService } from '../open-banking/open-banking.service';

export const TOKEN_STORAGE = 'token';
export const EXTERNAL_ID_STORAGE = 'externalId';
export const POS_ID_STORAGE = 'posId';
export const LOGIN_ID_STORAGE = 'loginId';
export const SOCIETY_CODE_STORAGE = 'societyCode';
export const OPEN_BANKING_AVAILABLE_STORAGE = 'openBankingAvailable';

@Component({
  selector: 'fol-init',
  templateUrl: './init.component.html',
  imports: [LoaderComponent, TranslatePipe]
})
export class InitComponent implements OnInit {
  private readonly router: Router = inject(Router);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly themingService: ThemingService = inject(ThemingService);
  private readonly applicationStore = inject(ApplicationStore);
  private readonly openBankingService = inject(OpenBankingService);

  ngOnInit(): void {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token');
    const posId = this.activatedRoute.snapshot.queryParamMap.get('posId');
    const loginId = this.activatedRoute.snapshot.queryParamMap.get('loginId');
    const societyCode = this.activatedRoute.snapshot.queryParamMap.get('societyCode');
    const externalId = this.activatedRoute.snapshot.queryParamMap.get('externalId');
    const isOpenBankingAvailable = this.activatedRoute.snapshot.queryParamMap.get('openBankingAvailable');

    if (token) {
      localStorage.setItem(TOKEN_STORAGE, token);
    }

    if (posId) {
      localStorage.setItem(POS_ID_STORAGE, posId);
    }

    if (externalId) {
      localStorage.setItem(EXTERNAL_ID_STORAGE, externalId);
    }

    if (loginId) {
      localStorage.setItem(LOGIN_ID_STORAGE, loginId);
    }

    if (societyCode) {
      localStorage.setItem(SOCIETY_CODE_STORAGE, societyCode);
    }

    if (isOpenBankingAvailable) {
      localStorage.setItem(OPEN_BANKING_AVAILABLE_STORAGE, isOpenBankingAvailable);
    }

    this.applicationStore.patch('pointOfSale', {
      societyCode: localStorage.getItem(SOCIETY_CODE_STORAGE) as SocietyCode
    });

    forkJoin([
      this.themingService.getThemingJson(
        new ThemingQueryParams({
          pointOfSaleCode: localStorage.getItem(POS_ID_STORAGE) ?? '',
          societyCode: localStorage.getItem(SOCIETY_CODE_STORAGE) ?? SocietyCode.CETELEM
        })
      ),
      this.openBankingService.openBankingNotificationExists(localStorage.getItem(EXTERNAL_ID_STORAGE) ?? '')
    ])
      .pipe(
        map(([_, openBankingNotificationExists]) => {
          if (openBankingNotificationExists) {
            this.router.navigateByUrl('/mobi-sub');
          } else {
            this.router.navigateByUrl('/step');
          }
        })
      )
      .subscribe();
  }
}
